import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import {
  registerTeamInfo,
  registerTeamLead,
  getTeamLeadData,
  getTeamMemberData,
} from "./../actions/form";

const ScienceOlympiad = ({
  registerTeamInfo,
  registerTeamLead,
  getTeamLeadData,
  getTeamMemberData,
}) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactNumber: 0,
    nic: 0,
    institute: "",
    ba: "",
    teamSize: "",
    member1name: "",
    member1nic: 0,
    member2name: "",
    member2nic: 0,
    member3name: "",
    member3nic: 0,
    member4name: "",
    member4nic: 0,
    member5name: "",
    member5nic: 0,
    member6name: "",
    member6nic: 0,
    member7name: "",
    member7nic: 0,
  });

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const {
      name,
      email,
      contactNumber,
      nic,
      institute,
      ba,
      teamSize,

      member1name,
      member2name,
      member3name,
      member4name,
      member5name,
      member6name,
      member7name,

      member1nic,
      member2nic,
      member3nic,
      member4nic,
      member5nic,
      member6nic,
      member7nic,
    } = formData;

    const result = await registerTeamLead({
      name,
      email,
      contactNumber,
      nic,
      institute,
      ba,
      teamSize,
    });

    if (result) {
      let result;
      if (teamSize === "3 to 4 people") {
        result = await registerTeamInfo({
          member1name,
          member2name,
          member3name,
          member4name,

          member1nic,
          member2nic,
          member3nic,
          member4nic,
        });
      } else {
        result = await registerTeamInfo({
          member1name,
          member2name,
          member3name,
          member4name,
          member5name,
          member6name,
          member7name,

          member1nic,
          member2nic,
          member3nic,
          member4nic,
          member5nic,
          member6nic,
          member7nic,
        });
      }

      if (result) {
        navigate(`/register/science-olympiad/step-two/${teamSize}/${"dsa"}`);
      }
    }
  };

  useEffect(() => {
    return () => {
      const getData = async () => {
        const teamLeadData = await getTeamLeadData();
        const teamMemberData = await getTeamMemberData();

        setFormData({ ...teamLeadData, ...teamMemberData });
      };

      getData();
    };
  }, [getTeamLeadData, getTeamMemberData]);

  return (
    <Layout>
      <div className="slider-area">
        <div className="single-slider hero-overly slider-height2 slider-bg2 d-flex align-items-center">
          <div className="container">
            <div className="row justify-content-center ">
              <div className="col-xxl-12">
                <div className="hero-caption hero-caption2">
                  <br />
                  <br />
                  <h2>Registration - Science Olmpiad</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="container p-4 pt-0">
        <form
          className="form-contact contact_form"
          onSubmit={(e) => onSubmit(e)}
        >
          <h1 className="text-light">Team Lead information</h1>
          <br />
          <div className="form-group">
            <input
              required
              className="form-control valid"
              name="name"
              id="name"
              value={formData.name}
              onChange={(e) => onChange(e)}
              type="text"
              placeholder="Enter your name"
            />
          </div>
          <div className="form-group">
            <input
              required
              className="form-control valid"
              name="email"
              id="email"
              value={formData.email}
              type="email"
              onChange={(e) => onChange(e)}
              placeholder="Enter your email"
            />
          </div>
          <div className="form-group">
            <input
              required
              className="form-control valid"
              name="contactNumber"
              id="contactNumber"
              value={formData.contactNumber}
              onChange={(e) => onChange(e)}
              type="number"
              placeholder="Enter your contact number"
            />
          </div>
          <div className="form-group">
            <input
              required
              className="form-control valid"
              name="nic"
              value={formData.nic}
              onChange={(e) => onChange(e)}
              id="nic"
              type="number"
              placeholder="Enter your NIC"
            />
          </div>
          <div className="form-group">
            <input
              required
              className="form-control valid"
              name="institute"
              value={formData.institute}
              onChange={(e) => onChange(e)}
              id="institute"
              type="text"
              placeholder="Enter your institute"
            />
          </div>
          <div className="form-group">
            <input
              required
              className="form-control valid"
              name="ba"
              id="ba"
              value={formData.ba}
              onChange={(e) => onChange(e)}
              type="text"
              placeholder="Enter your brand ambassador name"
            />
          </div>
          <h1 className="text-light">Team information</h1>
          <div className="form-group">
            <select
              className="form-control"
              name="teamSize"
              id="teamSize"
              value={formData.teamSize}
              onChange={(e) => onChange(e)}
              required
            >
              <option value="">Select your team size</option>
              <option value="3 to 4 people">3 to 4 people</option>
              <option value="5 to 7 people">5 to 7 people</option>
            </select>
          </div>
          {formData.teamSize !== "" && (
            <>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      name="member1name"
                      onChange={(e) => onChange(e)}
                      id="member1name"
                      type="text"
                      placeholder="Enter name of member 1"
                      value={formData.member1name}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      name="member1nic"
                      id="member1nic"
                      onChange={(e) => onChange(e)}
                      type="number"
                      value={formData.member1nic}
                      placeholder="Enter NIC of member 1"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      name="member2name"
                      onChange={(e) => onChange(e)}
                      id="member2name"
                      type="text"
                      value={formData.member2name}
                      placeholder="Enter name of member 2"
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      onChange={(e) => onChange(e)}
                      name="member2nic"
                      id="member2nic"
                      value={formData.member2nic}
                      type="number"
                      placeholder="Enter NIC of member 2"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      onChange={(e) => onChange(e)}
                      value={formData.member3name}
                      name="member3name"
                      id="member3name"
                      type="text"
                      placeholder="Enter name of member 3"
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      name="member3nic"
                      onChange={(e) => onChange(e)}
                      id="member3nic"
                      value={formData.member3nic}
                      type="number"
                      placeholder="Enter NIC of member 3"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      onChange={(e) => onChange(e)}
                      name="member4name"
                      value={formData.member4name}
                      id="member4name"
                      type="text"
                      placeholder="Enter name of member 4"
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      name="member4nic"
                      onChange={(e) => onChange(e)}
                      id="member4nic"
                      value={formData.member4nic}
                      type="number"
                      placeholder="Enter NIC of member 4"
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          {formData.teamSize === "5 to 7 people" && (
            <>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      onChange={(e) => onChange(e)}
                      value={formData.member5name}
                      name="member5name"
                      id="member5name"
                      type="text"
                      placeholder="Enter name of member 5"
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      name="member5nic"
                      value={formData.member5nic}
                      onChange={(e) => onChange(e)}
                      id="member5nic"
                      type="number"
                      placeholder="Enter NIC of member 5"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      name="member6name"
                      value={formData.member6name}
                      id="member6name"
                      type="text"
                      onChange={(e) => onChange(e)}
                      placeholder="Enter name of member 6"
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      name="member6nic"
                      onChange={(e) => onChange(e)}
                      value={formData.member6nic}
                      id="member6nic"
                      type="number"
                      placeholder="Enter NIC of member 6"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      onChange={(e) => onChange(e)}
                      name="member7name"
                      value={formData.member7name}
                      id="member7name"
                      type="text"
                      placeholder="Enter name of member 7"
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <input
                      required
                      className="form-control valid"
                      name="member7nic"
                      onChange={(e) => onChange(e)}
                      value={formData.member7nic}
                      id="member7nic"
                      type="number"
                      placeholder="Enter NIC of member 7"
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="form-group mt-3">
            <button
              type="submit"
              className="button button-contactForm btn_1 w-100"
            >
              Next
            </button>
          </div>
        </form>
      </section>
    </Layout>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  registerTeamLead,
  registerTeamInfo,
  getTeamLeadData,
  getTeamMemberData,
})(ScienceOlympiad);
